export const getShowError = state => state.showError;
export const getErrorMessage = state => state.errorMessage;
export const getErrorTitle = state => state.errorTitle;
export const getRedirectPageOnError = state => state.redirectPageOnError;
export const getRedirectPageOnErrorMessage = state => state.redirectPageOnErrorMessage;
export const getBlockEmailSubmission = state => state.blockEmailSubmission;

export default {
  getShowError,
  getErrorMessage,
  getErrorTitle,
  getRedirectPageOnError,
  getRedirectPageOnErrorMessage,
  getBlockEmailSubmission
};



// WEBPACK FOOTER //
// ./src/store/modules/errors/getters.js